import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AllAllergies {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  AllAllergiesData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: AllAllergies = {
  isLoading: false,
  error: false,
  message: null,
  AllAllergiesData: [],
  Items: [],
  Pagination: [],
};

const AllergiesSlice = createSlice({
  name: "allallergies",
  initialState,
  reducers: {
    loadingAllAllergies: (state: AllAllergies, action: PayloadAction<{}>) => {
      state.isLoading = true;
    },
    setAllAllergies: (state: any, action: PayloadAction<AllAllergies>) => {
      return action.payload;
    },
    clearData: (state: AllAllergies, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const { loadingAllAllergies, setAllAllergies, clearData } =
  AllergiesSlice.actions;

export default AllergiesSlice.reducer;
